module.exports = __webpack_public_path__ + "static/media/cq_ultimo_mese_option.a9bbe864.svg";